<header class="flex header">
  @if (category && category.id) {
    <h2>{{ 'Modal_Category.Edit_Category' | translate }}</h2>
  } @else {
    <h2>{{ 'Modal_Category.Add_Category' | translate }}</h2>
  }
  <p-button (onClick)="onClose()" icon="pi pi-times" />
</header>
<section class="content">
  <form [formGroup]="formGroup" class="col">
    <!-- Name -->
    <div class="form-box">
      <label for="name" ariaRequired="true">
        {{ 'Modal_Category.Name' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="name" formControlName="name" />
    </div>
    <!-- Description -->
    <div class="form-box">
      <label for="description" ariaRequired="true">
        {{ 'Modal_Category.Description' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="description" formControlName="description" />
    </div>

    <!-- Hidden until JWT are ready -->
    <!-- <h3 class="line">History</h3>
      <div class="form-box">
      <label for="createdBy">Created By</label>
      <p>
        {{ category?.createdBy }}
      </p>
    </div>
    <div class="form-box">
      <label for="modifiedBy">Modified By</label>
      <p>
        {{ category?.modifiedBy }}
      </p>
    </div>
    <div class="form-box">
      <label for="modifiedDate"> Modified Date </label>
      <p>
        {{ modifiedDate.value | date: 'yyyy-MM-dd' }}
      </p>
    </div> -->
  </form>
</section>
<footer>
  <p-button class="w-full" [label]="'Save' | translate" [disabled]="formGroup.invalid" />

  <p-button class="w-full" [label]="'Cancel' | translate" variant="outlined" (click)="onClose()" />
</footer>
